export default __webpack_public_path__ + "static/media/button-spinner.d5f9b293.svg";